import { useState, useEffect } from 'react';
import { useFetch } from './useFetch4';
import { api, Balance, BasePrice, CameraCatg, PcntOrder } from "../api";

interface BasePriceRecord {
    crn: string;
    value: number;
}

export type OrderParamsHookResult = ReturnType<typeof useOrderParams>;

export function useOrderParams({ initialPeriod = 1, mode = 'payment' } = {}) {
    const [currency, setCurrency] = useState('UAH');
    const [periodMon, setPeriodMon] = useState(initialPeriod);
    const { data: camerasAnalyticsFact } = useFetch<number>(api.getCameras, 0, {analytics_type: 1});
    const { data: camerasSimpleFact } = useFetch<number>(api.getCameras, 0, {analytics_type: 2});
    const { data: camerasAll } = useFetch<PcntOrder[]>(api.getPcntOrderQttyAll, [],);
    const [ camerasAnalytics, setCamerasAnalytics ] = useState(0);
    const [ camerasSimple, setCamerasSimple ] = useState(0);
    const [amount, setAmount] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [newEndDate, setNewEndDate] = useState<Date | undefined>(undefined);

    useEffect(() => {
        const analyticsRow = camerasAll.find(row => row.analytics_type === 1);
        const simpleRow = camerasAll.find(row => row.analytics_type === 2);
        setCamerasAnalytics(analyticsRow?.order_count ?? 0);
        setCamerasSimple(simpleRow?.order_count ?? 0);        
    }, [camerasAll]);

    useEffect(() => {
        const handleEffect = async () => {
            if (mode === 'payment') {
                const preInvoiceResult = await api.getPreInvoice({camerasAnalytics, camerasSimple, periodMon, currency});
                setAmount(preInvoiceResult?.amount || 0);
                setDiscount(preInvoiceResult?.discount || 0);
                setNewEndDate(preInvoiceResult?.end_date || undefined);
                // const rec = basePrice.find(r => r.crn === currency);
                // if (rec?.value) {
                //     const disc1 = getDiscount1(discountPrepaiment, periodMon);
                //     const disc2 = getDiscount2(discountQuantity, camerasAnalytics + camerasSimple);
                //     const sum = (camerasAnalytics + camerasSimple) * rec.value;
                //     const newAmount = +(sum * periodMon * disc1 * disc2).toFixed(2);
                //     const newDiscount = +(sum * periodMon - newAmount).toFixed(2);
                //     setAmount(newAmount);
                //     setDiscount(newDiscount);
                // } else {
                //     setAmount(0);
                //     setDiscount(0);
                // }
            } else
            if (mode === 'EndDate') {
                const preInvoicNopayeResult = await api.getPreInvoiceNoPay({camerasAnalytics, camerasSimple, });
                setNewEndDate(preInvoicNopayeResult?.end_date || undefined);
            } else {
                throw 'invalid mode';
            }
        };
        handleEffect();
    }, [camerasAnalytics, camerasSimple, periodMon, currency, ]);

    return {
        // поля ввода
        currency, setCurrency,
        periodMon, setPeriodMon,
        camerasAnalytics, setCamerasAnalytics,
        camerasSimple, setCamerasSimple,
        newEndDate, setNewEndDate,
        camerasAnalyticsFact,
        camerasSimpleFact,
        // вычисленные значения — доступны снаружи
        amount,
        discount,
    };
}
